import * as React from 'react';
import {renderReact} from 'hypernova-react';
import {I18nContext, I18nManager} from '@shopify/react-i18n';
import {Nav as NavComponent} from './Nav';

const manager = new I18nManager({locale: 'en-CA'});

function NavSection(props) {
  return (
    <I18nContext.Provider value={manager}>
      <NavComponent {...props} />
    </I18nContext.Provider>
  );
}

export default renderReact('Nav', NavSection);
